"use client";
import { useState, useRef } from 'react';
import { FaStethoscope, FaUserMd, FaHeartbeat, FaLaptopMedical, FaArrowRight } from 'react-icons/fa';
import JobDetailModal from '../components/popups/JobDetailModal';
import careesImage from '../assets/images/careerPage/group.svg'
import BreadcrumbsComponent from '../components/common/BreadcrumbsComponent';


interface JobPosition {
  id: number;
  title: string;
  department: string;
  type: string;
  location: string;
  description: string;
  requirements: string[];
}

const CareersPage = () => {
  const [selectedDepartment, setSelectedDepartment] = useState<string>('all');
  const [selectedJob, setSelectedJob] = useState<JobPosition | null>(null);
  const jobListingsRef = useRef<HTMLDivElement>(null);


  const BreadCrumbsPath = [
    {
      id: 1,
      pathName: "Carees",
      pathLink: "/careers",
    },
  ];


  const jobPositions: JobPosition[] = [
    // {
    //   id: 1,
    //   title: "Registered Nurse",
    //   department: "nursing",
    //   type: "Full-time",
    //   location: "Main Hospital",
    //   description: "Provide direct patient care, administer medications, and collaborate with healthcare teams to ensure optimal patient outcomes.",
    //   requirements: ["BSN degree", "Active RN license", "2+ years experience", "BLS certification"]
    // },
    {
      id: 1,
      title: "Medical Doctor",
      department: "medical",
      type: "Full-time",
      location: "Main Hospital",
      description: "Diagnose and treat patient conditions, develop treatment plans, and provide expert medical care.",
      requirements: ["Medical degree", "Board certification", "3+ years experience", "State medical license"]
    },
    // {
    //   id: 3,
    //   title: "IT Support Specialist",
    //   department: "administrative",
    //   type: "Full-time",
    //   location: "Administration Building",
    //   description: "Maintain hospital IT systems, provide technical support to staff, and ensure data security compliance.",
    //   requirements: ["Bachelor's in IT", "2+ years experience", "Knowledge of HIPAA compliance", "Network management skills"]
    // },
    // {
    //   id: 4,
    //   title: "Physical Therapist",
    //   department: "therapy",
    //   type: "Part-time",
    //   location: "Rehabilitation Center",
    //   description: "Help patients improve mobility, develop treatment plans, and document patient progress.",
    //   requirements: ["DPT degree", "State license", "1+ years experience", "Specialty certifications preferred"]
    // },
    // {
    //   id: 5,
    //   title: "Pharmacist",
    //   department: "pharmacy",
    //   type: "Full-time",
    //   location: "Hospital Pharmacy",
    //   description: "Dispense medications, provide drug information, and ensure safe medication practices.",
    //   requirements: ["PharmD degree", "State license", "2+ years hospital experience", "Knowledge of drug interactions"]
    // },
    // {
    //   id: 6,
    //   title: "Medical Records Clerk",
    //   department: "administrative",
    //   type: "Full-time",
    //   location: "Records Department",
    //   description: "Maintain patient records, ensure accuracy and confidentiality, and process record requests.",
    //   requirements: ["High school diploma", "1+ years experience", "Knowledge of EHR systems", "Attention to detail"]
    // }
  ];

  const departments = [
    { id: 'all', name: 'All Departments', icon: <FaHeartbeat className="text-green-600" /> },
    { id: 'medical', name: 'Medical', icon: <FaUserMd className="text-green-600" /> },
    { id: 'nursing', name: 'Nursing', icon: <FaStethoscope className="text-green-600" /> },
    { id: 'therapy', name: 'Therapy', icon: <FaHeartbeat className="text-green-600" /> },
    { id: 'administrative', name: 'Administrative', icon: <FaLaptopMedical className="text-green-600" /> },
    { id: 'pharmacy', name: 'Pharmacy', icon: <FaHeartbeat className="text-green-600" /> }
  ];

  const filteredJobs = selectedDepartment === 'all' ? jobPositions : jobPositions.filter(job => job.department === selectedDepartment);

  // Function to scroll to job listings
  const scrollToJobListings = () => {
    if (jobListingsRef.current) {
      jobListingsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleApply = (job: JobPosition) => {
    console.log('Applying for job:', job.title);
    setSelectedJob(null);
  };


  return (
    <>

      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="flex flex-col-reverse lg:flex-row bg-gradient-to-r from-green-50 to-blue-50  md:py-0 gap-2 lg:gap-0 py-5">
          <div className='md:px-10 px-5 w-full lg:w-1/2 flex items-center'>
            <div className="mx-auto text-left max-w-3xl">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Careers at MedLife Hospital</h1>
              <p className="text-xl text-gray-600 mb-8">
                Join our team of healthcare professionals dedicated to providing exceptional patient care and making a difference in our community.
              </p>
              <button
                onClick={scrollToJobListings}
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-300 transform hover:scale-105"
              >
                View Open Positions
              </button>
            </div>
          </div>

          <div className='w-full lg:w-1/2 flex justify-center items-center px-5 md:px-10'>
            <div className="relative w-full max-w-lg h-64 md:h-96">
              <img
                src={careesImage}
                alt='Healthcare professionals at MedLife Hospital'
                className='object-contain'
              />
            </div>
          </div>
        </section>
        <div>
          <BreadcrumbsComponent breadCrumbsPath={BreadCrumbsPath} />
        </div>

        {/* Benefits Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Why Work With Us</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { title: "Competitive Compensation", desc: "We offer competitive salaries and comprehensive benefits packages." },
                { title: "Work-Life Balance", desc: "Flexible scheduling options to help you maintain a healthy work-life balance." },
                { title: "Professional Growth", desc: "Continuing education opportunities and career advancement paths." },
                { title: "State-of-the-Art Facilities", desc: "Work with the latest medical technology and equipment." },
                { title: "Supportive Team", desc: "Collaborative environment with a focus on teamwork and mutual respect." },
                { title: "Community Impact", desc: "Make a meaningful difference in the lives of patients and the community." }
              ].map((benefit, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                    <div className="w-6 h-6 bg-green-600 rounded-full"></div>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Job Listings Section with ref */}
        <section ref={jobListingsRef} className="py-16 bg-gray-50 ">
          <div className="container mx-auto px-4 mt-5">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">Current Openings</h2>
            <p className="text-gray-600 text-center mb-12">Explore our available positions and find where you fit in our healthcare team.</p>

            {/* Department Filter */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {departments.map(dept => (
                <button
                  key={dept.id}
                  onClick={() => setSelectedDepartment(dept.id)}
                  className={`flex items-center px-4 py-2 rounded-full ${selectedDepartment === dept.id ? 'bg-green-600 text-white' : 'bg-white text-gray-700 border border-gray-200'}`}
                >
                  <span className="mr-2 bg-white rounded-full p-1 items-center justify-center flex">{dept.icon}</span>
                  {dept.name}
                </button>
              ))}
            </div>

            {/* Job Listings */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {filteredJobs.map(job => (
                <div key={job.id} className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{job.title}</h3>
                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">{job.type}</span>
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">{job.location}</span>
                  </div>
                  <p className="text-gray-600 mb-4">{job.description}</p>
                  <button
                    onClick={() => setSelectedJob(job)}
                    className="text-green-600 hover:text-green-700 font-medium flex items-center"
                  >
                    View Details
                    <FaArrowRight className="ml-2" />
                  </button>
                </div>
              ))}
            </div>

            {filteredJobs.length === 0 && (
              <div className="text-center py-12">
                <p className="text-gray-600">No positions available in this department at the moment.</p>
                <p className="text-gray-600 mt-2">Please check back later or explore other departments.</p>
              </div>
            )}
          </div>
        </section>
        <JobDetailModal
          selectedJob={selectedJob}
          onClose={() => setSelectedJob(null)}
          onApply={handleApply}
        />

      </div>
    </>
  );
};

export default CareersPage;